import { useLayoutEffect } from 'react';

/**
 * Publishes the visual viewport as --vvh / --vv-top on the given element, so a fixed overlay can
 * match the area left above an on-screen keyboard. Without visualViewport support, or while the
 * page is pinch-zoomed, the variables are removed and CSS falls back to dvh.
 */
const useVisualViewport = (elementRef, active = true) => {
    useLayoutEffect(() => {
        const viewport = window.visualViewport;
        const element = elementRef.current;
        if (!active || !viewport || !element) return undefined;

        const update = () => {
            if (viewport.scale > 1.01) {
                element.style.removeProperty('--vvh');
                element.style.removeProperty('--vv-top');
                return;
            }

            element.style.setProperty('--vvh', `${viewport.height}px`);
            element.style.setProperty('--vv-top', `${viewport.offsetTop}px`);

            const focused = document.activeElement;
            if (focused && focused !== document.body && element.contains(focused)) {
                focused.scrollIntoView({ block: 'nearest' });
            }
        };

        update();
        viewport.addEventListener('resize', update);
        viewport.addEventListener('scroll', update);

        return () => {
            viewport.removeEventListener('resize', update);
            viewport.removeEventListener('scroll', update);
        };
    }, [elementRef, active]);
};

export default useVisualViewport;
